import { memo } from "react"

const Discounts = () => {
    return (
        <div className="m-container">
            آموزش ها
        </div>
    )
}

export default memo(Discounts);